<template>
  <div>
    <marc-error v-if="error" cass="marc-display" :error="error"/>
    <marc-display v-else-if="record" class="marc-display" :record="record"/>
    <div v-else>
      <div class="loading">
        <span>Loading record, please wait...</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import MarcDisplay from "./MarcDisplay.vue"
import MarcError from "./MarcError.vue"

export default {
  name: "Main",
  components: {
    MarcDisplay,
    MarcError
  },
  data: () => ({
    url: null,
    record: null,
    error: null
  }),
  mounted() {
    const json_url = location.pathname.slice(0, -1) + '.json';
    this.url = json_url
    axios({
      url: json_url,
      method: 'get',
    }).then( (result) => {
      this.record = result.data;
    }).catch( (err) => {
      if (err.response) {
        // client received an error response (5xx, 4xx)
        this.error = err.response;
      } else {
        // No idea how to manage it
        console.log(result);
      }
    });
  }
}
</script>

<style scoped>
.marc-display {
  padding-top: 7px;
}
.loading {
  padding-top: 15px;
}
</style>
